module.exports = __webpack_public_path__ + "images/psp/militarySizeGuide/unit-10x10.svg";